const namespace = '[ENTITY_DISPATCHES]';
export const FETCH_DISPATCHES = `${namespace} FETCH_DISPATCHES`;
export const SET_DISPATCHES = `${namespace} SET_DISPATCHES`;
export const REMOVE_DISPATCH = `${namespace} REMOVE_DISPATCH`;
